import { Component, OnInit, Input, Inject, Output, EventEmitter, Optional, OnChanges } from '@angular/core';
import {
  CheckSuitabilityDataObj,
  SimpleActivity,
  DataIds,
  ISaveSimpleActivity,
} from '../../../shared/models/activity-dashboard-model';
import { ActivityService } from '../../../core/services/activity.service';
import { SnackbarComponent } from '../../../shared/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileService } from '../../../core/services/file.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';

@Component({
  selector: 'app-coupled-suitability-activity',
  templateUrl: './coupled-suitability-activity.component.html',
  styleUrls: ['./coupled-suitability-activity.component.scss'],
  standalone: false,
})
export class CoupledSuitabilityActivityComponent implements OnInit, OnChanges {
  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  toggleBtn: boolean = false;
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  existingFileData: any;
  companyHiringType: any; //= 1;

  public isCollapsed: boolean = false;

  inputValue: string;
  ids: DataIds;
  notes: string;
  //time
  public timeModifiedOn: string;

  isDeleteDisable: boolean = true;
  // ..
  @Input() checkSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() candidateApplicationIds: number[];
  @Input() ifCoupled: boolean;
  loginUserName: string;
  editactivity: boolean = false;
  userloggedin: any;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();
  @Output() coupledformValid: EventEmitter<boolean> = new EventEmitter();
  // @Input() dialogRef: MatDialogRef<ActivityDialogComponent>;
  dataSnackbar: any = {
    msg: '',
    isSuccess: false,
  };
  editCheckSuitabilityDataObj: CheckSuitabilityDataObj;
  constructor(
    private activityService: ActivityService,
    private _snackBar: MatSnackBar,
    private fileService: FileService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.checkSuitabilityDataObj = data.checkSuitabilityDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }

  ngOnInit() {
    this.notes = '';
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');

    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.attributes.name[0];
    console.log(this.loginUserName);

    // this.editId = { objectId: this.checkSuitabilityDataObj.applicationId, objectType: 'AP' };

    console.log(this.editId);
    console.log('hi');
    console.log(this.editactivity);

    if (this.editactivity) {
      console.log(this.checkSuitabilityDataObj);
      this.editId = {
        objectId: this.checkSuitabilityDataObj.applicationId,
        objectType: 'AP',
        activityId: this.checkSuitabilityDataObj.activityId,
      };
      this.getActivity(this.checkSuitabilityDataObj);
      // /.applicationId, this.checkSuitabilityDataObj.activityId, this.checkSuitabilityDataObj.processId);
    }
    this.showMoreLess();
  }
  testformValid(flag) {
    console.log('couple form valid');
    this.coupledformValid.emit(flag);
  }
  ngOnChanges() {
    this.notes = '';
  }

  openSnackBar(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      duration: 2000,
    });
  }

  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }
  // validForm(f){
  //   console.log('form value',f);
  //   if(this.notes === null || this.notes==='' ) {
  //     return false;
  //   } else {
  //     return true;
  //   }

  // }

  activityAction() {
    console.log('inside cople itabilirt');
    if (this.editactivity) {
      const SimpleActivityObj: SimpleActivity = {
        applicationIds: this.checkSuitabilityDataObj.applicationId,
        processID: this.checkSuitabilityDataObj.processId,
        activityID: this.checkSuitabilityDataObj.activityId,
        notes: this.notes,
        createdOn: this.checkSuitabilityDataObj.createdOn,
        createdBy: this.checkSuitabilityDataObj.createdBy,
      };
      this.editActivity(SimpleActivityObj);
    } else {
      let ISaveSimpleObjS: ISaveSimpleActivity;
      if (this.candidateApplicationIds.length > 0) {
        ISaveSimpleObjS = {
          applicationIds: this.candidateApplicationIds,
          processID: this.checkSuitabilityDataObj.processId,
          activityID: this.checkSuitabilityDataObj.activityId,
          notes: this.notes,
        };
      }
      this.saveActivity(ISaveSimpleObjS);
    }
    this.showMoreLess();
  }
  // Mock function to get data from input field.
  saveActivity(ISaveSimpleobj: ISaveSimpleActivity) {
    console.log('inside save activity of checksuitability');
    if (this.inputValue !== '') {
      this.activityService.saveSimpleActivity(ISaveSimpleobj).subscribe(
        (result: any) => {
          console.log(result);
          if (result.error && result.error.toLowerCase() === 'failure') {
            const data = {
              msg: result.message,
              isSuccess: 'error',
            };

            console.log(data);
            this.activityService.openSnackBar(data, 'danger-snack');
          } else {
            this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.companyHiringType);

            console.log('snackbar if in ts');
            const data1 = {
              msg: result.message,
              isSuccess: 'created',
            };

            console.log(data1);
            this.activityService.openSnackBar(data1, 'success-snack');
            this.refreshcandiates.emit('true');
          }
        },
        (err) => {
          const data = {
            msg: 'Some error occurred',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data, 'danger-snack');
          console.log('err-->', err);
        },
      );
    }
  }

  editActivity(editObj1: SimpleActivity) {
    console.log('inside edit activity');
    this.activityService.editSimpleActivity(editObj1).subscribe(
      (_result: string) => {
        this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.companyHiringType);
        const data1 = {
          msg: 'Data Updated Successfully !!!',
          isSuccess: true,
        };

        this.activityService.openSnackBar(data1, 'success-snack');
      },
      (_err) => {
        const data2 = {
          msg: 'Some error Occurred',
          isSuccess: false,
        };

        this.activityService.openSnackBar(data2, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getActivity(obj1: CheckSuitabilityDataObj) {
    this.activityService
      .getSimpleActivity(obj1.applicationId, obj1.activityId, obj1.processId, obj1.createdOn)
      .subscribe((resp: SimpleActivity) => {
        this.dataInitialization(resp);
      });
  }

  dataInitialization(activityObj1: SimpleActivity) {
    if (activityObj1.notes === null) {
      this.notes = '';
      this.isDeleteDisable = true;
      // console.log("IF_inside dataInitialization" + this.isDeleteDisable);
    } else {
      //console.log('form vlaue notes',f.value.notes);
      this.notes = activityObj1.notes;
      // time
      this.timeModifiedOn = activityObj1.modifiedOn;
      this.isDeleteDisable = false;
      // console.log("ELSE_inside dataInitialization" + this.isDeleteDisable);
    }
  }

  // file upload
  receiveFileOutput(filedata1) {
    console.log('inside recievefile format');
    this.fileData = filedata1['fileMerge'];
    this.deletedFile = filedata1['deletedFile'];
    console.log(this.fileData);
    console.log(this.deletedFile);
  }

  recieveExistingFile(filedata1) {
    this.existingFileData = filedata1['existingFileArray'];
    console.log(this.existingFileData);
  }
  saveAttachment(genericId, companyHiringTypeId) {
    console.log('inside saveattachmnt suitability');
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file1) => {
        this.fileService.deleteFile(file1.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data1 = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data1, 'danger-snack');
          },
        );
      });
    }
    const activityId1: any = this.checkSuitabilityDataObj.activityId;
    const fd1 = new FormData();
    fd1.append('objectId', genericId);
    fd1.append('objectType', 'AP');
    fd1.append('attachmentId', '2');
    fd1.append('companyHiringTypeId', companyHiringTypeId);
    fd1.append('activityId', activityId1);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd1.append('file[' + file.name + ']', file);
      });
      console.log(fd1);
      this.fileService.upload(fd1).subscribe(
        (_res) => {},
        (_err) => {},
      );
    }
  }
}
